import { Button, Form, Input, List, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import EventEmitter from '../../utils/eventEmitter';
import { useNavigate } from 'react-router-dom';
// import Axios from '../utils/axios';



// let pos_session = {
//   orders: [{
//     status: 'new',
//     is_ordered: false,
//     is_selected: true,
//     customer_id: '',
//     receipt_number: codes.receipt_no,
//     order_ref: codes.order_no,
//     delivery_region_id: '',
//     is_refund: false,
//     note: '',
//     pick_later: false,
//     demand_sold: false,
//     orderlines: [],
//     paymentLines: [],
//     createdAt: Date.now(),
//     user_id: ''
//   }],
// };


const MyFooter = ({ handleCancel }) => {
  return (
    <div className='flex justify-end pt-2'>
      <Button onClick={handleCancel} danger>Cancel</Button>
    </div>
  )
};

const SelectCashierModal = ({cashiers}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();


  const handleCancel = () => {
    setIsModalOpen(false);
  };
  
  const handleOnClick = async (item) => {
    try {
      let storage = localStorage.getItem(`caspian_pos_session`);
      let caspianpos = JSON.parse(storage);
      if (caspianpos) {
        if (item.pin) {
          EventEmitter.dispatch('openpinmodal', item);
          setIsModalOpen(false);
        }else {
          let data = {id: item.id, name: item.name, pin: item.pin };
          EventEmitter.dispatch('cashier_choosen', data);
          localStorage.setItem(`caspian_pos_cashier`, JSON.stringify(data));
          navigate('/pos/session/sells');
        }
      }
    }catch (err) {
      console.log(err);
    }
  }

  

  useEffect(() => {
    EventEmitter.subscribe('openselectcashier', info => {
      console.log(info)
      // Axios.get('payment-methods')
      // .then(res => setPaymentMethods(res.data))
      // .catch(err => console.log(err))
      setIsModalOpen(info);
    });
    
    
    return () => {
      EventEmitter.unsubscribe('openselectcashier');
    }
  },[])



  return (
    <Modal title="Choose Cashier" centered wvalueth={'400px'} open={isModalOpen} onCancel={handleCancel} footer={<MyFooter handleCancel={handleCancel}/>}>
      <div>
        <List 
          itemLayout='vertical'
          dataSource={cashiers}
          renderItem={(item, index) => (
            <div key={index} onClick={()=>handleOnClick(item)} className='hover:cursor-pointer hover:bg-gray-200 p-3 border-b'>{item.name}</div>
          )}
        />
      </div>
    </Modal>
  )
}

export default SelectCashierModal;